import React, { useEffect } from 'react';
import { useGetLPAssignedToMeQuery } from '../../LearningPaths.queries';
import Loading from 'shared_ui_components/Loading';
import LearningPathTopCard from './LearningPathTopCard';
import styles from './AssignedLearningPathDetails.module.scss';
import stylesFocus from './FocusLearningPaths.module.scss';
import LearningPathContents from './LearningPathContents';
import { useLearningPathsStore } from '../../LearningPaths.store';
import { useGetFF } from 'hooks/useGetFF';
import FocusLearningPathHeader from './FocusLearningPathHeader';
import FocusLearningPathsContents from './FocusLearningPathsContents';

const AssignedLearningPathDetails = ({ uuid }) => {
  const { data = {}, isLoading, isError } = useGetLPAssignedToMeQuery({ uuid });
  const { setSelectedRepLearningPathID } = useLearningPathsStore();
  const { isEnabled: ff_learningPaths } = useGetFF({ flag_id: 'learning_paths' });

  useEffect(() => {
    if (isError) setSelectedRepLearningPathID('');
  }, [setSelectedRepLearningPathID, isError]);

  if (isLoading) return <Loading loading circular />;
  return (
    <>
      {ff_learningPaths ? (
        <div className={stylesFocus.container}>
          <FocusLearningPathHeader learningPath={data}/>
          <FocusLearningPathsContents learningPath={data}/>
        </div>
      ) : (
        <div className={styles.container}>
          <LearningPathTopCard learningPath={data} />
          <LearningPathContents learningPath={data} />
        </div>
      )}
    </>
  );
};

export default AssignedLearningPathDetails;
